"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

/**
 * Intercepts punchout_cart or session_id query params on ANY dashboard page.
 *
 * Uses window.location.search directly (NOT useSearchParams) to avoid
 * Next.js App Router layout limitations where useSearchParams may not
 * re-trigger on full-page browser navigations (meta-refresh, window.location.href).
 *
 * Also handles the case where session_id is present but EMPTY — falls back
 * to a session_id stored in sessionStorage at punchout start time.
 */
export function PunchoutInterceptor() {
  const router = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const punchoutCart = params.get("punchout_cart");
    const sessionIdFromUrl = params.get("session_id");

    // Detect punchout return: either punchout_cart param OR session_id param present
    // (even if value is empty — Sonepar sometimes sends /?session_id= without a value)
    const hasPunchoutCart = !!punchoutCart;
    const hasSessionIdParam = params.has("session_id");

    if (!hasPunchoutCart && !hasSessionIdParam) return;

    // Recover session_id: prefer URL value, fall back to stored value from startPunchout
    const sessionId =
      (sessionIdFromUrl && sessionIdFromUrl.trim() !== ""
        ? sessionIdFromUrl
        : null) ?? sessionStorage.getItem("last_punchout_session_id") ?? "";

    console.log("[PunchoutInterceptor] Paramètres punchout détectés dans l'URL", {
      punchoutCart: !!punchoutCart,
      sessionIdFromUrl,
      sessionIdUsed: sessionId,
      path: window.location.pathname,
    });

    // Forward to /punchout/return which has all the cart processing logic
    const forwardParams = new URLSearchParams();
    if (punchoutCart) forwardParams.set("punchout_cart", punchoutCart);
    if (sessionId) forwardParams.set("session_id", sessionId);

    router.replace(`/punchout/return?${forwardParams.toString()}`);
  }, []); // Run once on mount — full-page redirect always re-mounts React tree

  return null;
}
